<template>
  <div class="page-content">
    <div class="contenter">
      <el-tabs v-model="activeName" type="card" @tab-click="handleTabChange" :before-leave='handleBeforeLeave'>
        <el-tab-pane label="安全用电" name="electricitySafety">
          <electricity-safety ref="electricitySafety"></electricity-safety>
        </el-tab-pane>
        <el-tab-pane label="房间用电" name="roomElectricity">
          <room-electricity ref="roomElectricity"></room-electricity>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import electricitySafety from './electricitySafety.vue'
import roomElectricity from './roomElectricity.vue'
export default {
  name: 'siteMonitoring',
  components: {
    electricitySafety,
    roomElectricity
  },
  data () {
    return {
      activeName: 'electricitySafety'
    }
  },
  created () {},
  methods: {
    handleTabChange (val) {
      this.$refs[val.name].handleGetTreeList()
    },
    handleBeforeLeave (newTab, oldTab) {
      this.$refs[oldTab].handleBeforeLeave()
    }
  }
}
</script>

<style lang="scss" scoped>
.page-content {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  color: #333;
  padding: 16px;
  .contenter {
    width: 100%;
    height: 100%;
    padding: 8px;
    box-sizing: border-box;
    background-color: #fff;
  }
}

.el-tabs {
  height: 100%;
  ::v-deep .el-tabs__content{
    height: calc(100% - 60px);
  }
  .el-tab-pane {
    height: 100%;
  }
}
</style>
